import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../app/providers/StoreProvider'
import {
    AboutData,
    BenefitsSectionData,
    ContactData,
    DetailsSectionData,
    FeaturesSectionData,
    GallerySectionData,
    PriceSectionData
} from '../types/PageContentSchema'

const pickFirst = <T,>(items: T[]): T | null => items[0] ?? null

const fetchSection = async <T,>(
    api: ThunkConfig<string>['extra']['api'],
    path: string
): Promise<T | null> => {
    try {
        const response = await api.get<T[]>(path)
        return pickFirst(response.data)
    } catch {
        return null
    }
}

export const fetchPageContent = createAsyncThunk<
    {
        locale: string
        contact: ContactData | null
        about: AboutData | null
        features: FeaturesSectionData | null
        details: DetailsSectionData | null
        price: PriceSectionData | null
        gallery: GallerySectionData | null
        benefits: BenefitsSectionData | null
    },
    string,
    ThunkConfig<string>
>('pageContent/fetchPageContent', async (locale, thunkApi) => {
    const { extra } = thunkApi
    const normalizedLocale = locale.split('-')[0]

    const [contact, about, features, details, price, gallery, benefits] =
        await Promise.all([
            fetchSection<ContactData>(extra.api, '/contact'),
            fetchSection<AboutData>(extra.api, '/about'),
            fetchSection<FeaturesSectionData>(extra.api, '/features'),
            fetchSection<DetailsSectionData>(extra.api, '/details'),
            fetchSection<PriceSectionData>(extra.api, '/price'),
            fetchSection<GallerySectionData>(extra.api, '/gallery'),
            fetchSection<BenefitsSectionData>(extra.api, '/benefits')
        ])

    return {
        locale: normalizedLocale,
        contact,
        about,
        features,
        details,
        price,
        gallery,
        benefits
    }
})
